import { Flex, Skeleton } from 'front-commons/ds';
import { PromoDetailsCardSkeleton } from 'front-commons/ds/components/ProductCard/variants/PromoDetailsCard/components/Skeleton';
import { FooterPromotionDetails, ProductCards, SummarySeparator } from './styles';

export default function Skeletons() {
	return (
		<>
			<Flex flex="1" direction="column" padding="1rem">
				<Flex gap="1rem" direction="column">
					<Skeletons.Description />
					<Skeletons.Search />
					<Skeletons.ProductCards />
				</Flex>
			</Flex>

			<Skeletons.Summary />
		</>
	);
}

Skeletons.Description = () => (
	<Flex gap="0.5rem" direction="column">
		<Flex justifyContent="space-between" alignItems="center">
			<Skeleton maxWidth="134px" height="16px" />
			<Skeleton maxWidth="72px" height="21px" />
		</Flex>

		<Flex gap="0.5rem" direction="column">
			<Skeleton maxWidth="278px" height="24px" />

			<Flex gap="0.5rem">
				<Skeleton maxWidth="80px" height="20px" />

				{/* TODO: uncomment once we have the link redirecting to a page with only hypera products */}
				{/* <Skeleton maxWidth="38px" height="20px" /> */}
			</Flex>
		</Flex>
	</Flex>
);

Skeletons.Search = () => (
	<Flex gap="0.125rem" direction="column">
		<Skeleton maxWidth="91px" height="21px" />
		<Skeleton height="32px" />
	</Flex>
);

Skeletons.ProductCards = () => {
	return (
		<ProductCards>
			<PromoDetailsCardSkeleton />
			<PromoDetailsCardSkeleton />
			<PromoDetailsCardSkeleton />
		</ProductCards>
	);
};

Skeletons.Summary = () => (
	<FooterPromotionDetails>
		<Flex gap="0.5rem" direction="column">
			<Skeleton maxWidth="65px" height="21px" />

			<SummarySeparator />

			<Flex justifyContent="space-between">
				<Skeleton maxWidth="113px" height="24px" />
				<Skeleton maxWidth="71px" height="24px" />
			</Flex>
		</Flex>

		<Flex justifyContent="end">
			<Skeleton width="240px" height="40px" />
		</Flex>
	</FooterPromotionDetails>
);
